<template>
  <div class="bullets">
    <a
      v-for="(item, index) in steps"
      :key="index"
      href="#"
      class="bullet"
      :class="{ '-active': activeStep === index + 1 }"
    ></a>
  </div>
</template>
<script>
export default {
  props: {
    steps: {
      type: Number
    },
    activeStep: {
      type: Number
    }
  }
};
</script>

<style lang="scss" scoped>
.bullets {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 30px;
  left: 0;
  width: 100%;
  z-index: 100;
}

.bullet {
  width: 13px;
  height: 3px;
  background: $white-60;
  margin-right: 10px;
  position: relative;
  pointer-events: none;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -10px;
    top: -10px;
  }

  &:last-child {
    margin-right: 0;
  }

  &.-active {
    background: $yellow;
    width: 40px;
  }
}
</style>
